<script lang="ts">
    import FeatherIcon from "svelte-feather-icon";
    import { href } from "../../../utils/Constant/Constant";
    import Link from "svelte-link";
    export let bookmarkItem:any
</script>
<div class="desciption-data">
    <div class="title-bookmark">
        <h6 class="title_0">{bookmarkItem.header}</h6>
        <p class="weburl_0">{bookmarkItem.link}</p>
        <div class="hover-block">
            <ul>
              <ul>
                <li>
                  <Link href={href} >
                      <FeatherIcon icon="edit-2" />
                  </Link>
                </li>
                <li><Link href={href}><FeatherIcon icon="link"/></Link></li>
                <li><Link href={href}><FeatherIcon icon="share-2"/></Link></li>
                <li><Link href={href}><FeatherIcon icon="trash-2"/></Link></li>
                <li class="pull-right text-end">
                  <Link href={href} >
                      <FeatherIcon icon="tag"/>
                  </Link>
              </li>
              </ul>
            </ul>
        </div>
        <div class="content-general">
            <p class="desc_0">{bookmarkItem.content}</p>
            <span class={bookmarkItem.class}>{bookmarkItem.title}</span>
        </div>
    </div>
</div>